import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import styles from './faqentitats.module.scss';

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    title?: string;
    novaFinestra?: boolean;
    className?: string;
    children: React.ReactNode;
}>;

const IMG_BASE = 'https://statics.3cat.cat/recursos/marato/img/espai-entitats';

interface BotoFaq {
    href: string;
    title: string;
    img: string;
    text: string;
    novaFinestra?: boolean;
}

const BOTONS_PRINCIPALS: BotoFaq[] = [
    {
        href: '#disponibilitat-material',
        title: 'Enllaç a com obtenir material promocional',
        img: 'img-materialPromo.marato.png',
        text: 'Per obtenir el material promocional'
    },
    {
        href: '#utilitzar-logo',
        title: 'Enllaç a les instruccions de com utilitzar el logo',
        img: 'img-utilitzarLogo.marato.png',
        text: 'Per utilitzar el logo'
    },
    {
        href: '#aconseguir-pancarta',
        title: 'Enllaç a com aconseguir una pancarta',
        img: 'img-pancarta.marato.png',
        text: 'Per aconseguir una pancarta'
    },
    {
        href: '#sortir-programa',
        title: 'Enllaç a les instruccions de com aparèixer al programa',
        img: 'img-programa.marato.png',
        text: 'Per aparèixer al programa'
    },
    {
        href: '#enviar-imatges',
        title: 'Enllaç a com enviar imatges de la vostra activitat al Web',
        img: 'img-enviaImg.marato.png',
        text: 'Per enviar imatges de la vostra activitat al Web'
    },
    {
        href: '#informe-recaptacio',
        title: 'Enllaç a com informar de la recaptació aconseguida',
        img: 'img-informaRecaudacio.marato.png',
        text: 'Per informar de la recaptació aconseguida'
    },
    {
        href: '#dades-fundacio',
        title: 'Enllaç a les dades sobre la Fundació La Marató de 3Cat',
        img: 'img-sobreFundacio.marato.png',
        text: 'Sobre la Fundació La Marató de 3Cat'
    },
    {
        href: '#faq_contrasenya',
        title: 'Enllaç a recuperar contrasenya',
        img: 'img-password.marato.png',
        text: 'Recuperació de contrasenya'
    }
];

const BOTONS_ACCIO: BotoFaq[] = [
    {
        href: '/tv3/marato/instruccions-ingres',
        title: "Instruccions d'ingrés",
        img: 'img-ingressarRecaudacio.marato.png',
        text: 'Per ingressar els diners recaptats',
        novaFinestra: true
    },
    {
        href: '/3cat/com-comunicar-la-vostra-recaptacio/video/5680575/',
        title: 'Enllaç a vídeo explicatiu',
        img: 'img-miraVideo.marato.png',
        text: 'Per comunicar la recaptació, mireu el vídeo',
        novaFinestra: true
    }
];

export default function FaqEntitats() {
    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.botonsPrincipals}>
                    {BOTONS_PRINCIPALS.map((boto) => (
                        <Enllac key={boto.href} href={boto.href} title={boto.title} className={styles.boto}>
                            <Imatge src={`${IMG_BASE}/${boto.img}`} alt='' width={123} height={39} />
                            <span className={styles.text}>{boto.text}</span>
                        </Enllac>
                    ))}
                </div>
                <div className={styles.botonsAccio}>
                    {BOTONS_ACCIO.map((boto) => (
                        <Enllac
                            key={boto.href}
                            href={boto.href}
                            title={boto.title}
                            novaFinestra={boto.novaFinestra}
                            className={[styles.boto, styles.botoGroc].join(' ')}
                        >
                            <Imatge src={`${IMG_BASE}/${boto.img}`} alt='' width={123} height={39} />
                            <span className={styles.text}>{boto.text}</span>
                        </Enllac>
                    ))}
                </div>
            </div>
        </>
    );
}
